
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_40467)"}},[_c('path',{attrs:{"d":"M9.93 15.853H1.36v5.143a1.714 1.714 0 001.714 1.714h5.143a1.714 1.714 0 001.714-1.714v-5.143zM23.646 15.853h-8.572v5.143a1.714 1.714 0 001.714 1.714h5.143a1.714 1.714 0 001.715-1.714v-5.143zM9.934 15.853h5.143"}}),_c('path',{attrs:{"d":"M23.643 15.853V5.567a3.429 3.429 0 00-3.429-3.428H18.5M1.36 15.853V5.567A3.429 3.429 0 014.787 2.14h1.714"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_40467"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .424)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    